import { FormularioCondominio } from 'src/app/constants/forms/formularioCondominio';
import { Injectable } from '@angular/core';
import { CotacaoRamoService } from './cotacao-ramo.service';
import { UtilsService } from '../utils.service';
import { IntegracaoConstants } from 'src/app/constants/integracao';
import { CalcsResults } from 'src/app/models/calculos/calcs-results.model';
import { CalcEntity } from 'src/app/models/calcEntity.model';
import { CalcPacote } from 'src/app/models/calcPacote.model';
import { LeadsConstants } from 'src/app/constants/leads';
import { ApiUsuarioService } from '../api-usuario.service';

@Injectable({
  providedIn: 'root'
})

export class CotacaoCondominioService implements CotacaoRamoService {
  public _leadsCadastrados = LeadsConstants.leads;
  public _seguradorasBase = IntegracaoConstants.seguradoras;
  private _franquias = IntegracaoConstants.tipoFranquiaTxt;
  private _coberturasMulti = IntegracaoConstants.tipoCoberturaMultiTxt;
  private _sexo = IntegracaoConstants.sexoTxt;
  private _profissoes = IntegracaoConstants.profissoesTxt;
  private _estadoCivil = IntegracaoConstants.estadoCivilTxt;
  private _tpUso = IntegracaoConstants.tpUsoTxt;
  private _carroReserva = IntegracaoConstants.carroReservaTxt;
  private _assist24hs = IntegracaoConstants.assist24hsTxt;
  private _stepsId = IntegracaoConstants.stepsId;
  private _ramos = IntegracaoConstants.ramos;
  private _tipoCondominioTxt = IntegracaoConstants.tipoCondominioTxt;
  private vidaGrupoTxt = IntegracaoConstants.vidaGrupoTxt;
  private qtdVagasGaragem = IntegracaoConstants.qtdVagasGaragemTxt;
  private tpGuardaVeic = FormularioCondominio.tpGuardaTerceirizada;
  public dadosUser: any = []
  private _packageType = IntegracaoConstants.packageType;

  private tipoReq = 5;

  constructor(private utilsService: UtilsService, private apiUsuario: ApiUsuarioService) { }

  async setDadosUser(){
    try{
        let dt = await this.apiUsuario.getListCfgsSegs()
        console.log(dt)
        if (dt)
          this.dadosUser = dt
        else
          this.dadosUser = false
    }catch(err){
      console.log(err)
       this.dadosUser = false
    }
  }

  sessoesPDF() {
    return [{
      code: 1,
      description: 'Segurado/Bem Segurado',
      selected: true
    },
    {
      code: 2,
      description: 'Caracteristícas',
      selected: true
    },
    {
      code: 3,
      description: 'Coberturas',
      selected: true
    },
    {
      code: 4,
      description: 'Cálculos com erro',
      selected: true
    }];
  }

  setComissaoDefault(su) {
    su.percComissao = su.percComissaoCond;
    su.percDesconto = su.percDescontoCond;
    return su;
  }

  setCoberturas(v, obj) {
    return null;
  }

  getMessageCalcExtension(subramo?) {
    return 'VER_CALCULO_CONDOMINIO'
  }

  getColumnsGridCalculosVersao() {
    return ['seguradora', 'premio', 'comissao', 'incendio', 'eletricos', 'isDanosVendaval', 'isDanosImpactoVeiculo', 'rc-sindico', 'tempo'];
  }

  getCalcObject(draft, seguradoras, coberturas) {

    let obj = JSON.parse(JSON.stringify(draft));
    let propertiesToDelete = ['automoveis', 'placa', 'chassi', 'modelo'];
    propertiesToDelete.map(function (pd) {
      delete obj[pd];
    });

    // obj.ramo = this._ramos.RESIDENCIAL;
    obj.tipo = 5;

    let hoje = new Date();
    let vigIni = new Date(obj.vigenciaIni);
    let limiteRetroativo: any = new Date();
    limiteRetroativo = this.utilsService.editarData({ data: limiteRetroativo, operacao: '-', dia: 15, mes: 0, ano: 0 });

    if (limiteRetroativo)
      if (limiteRetroativo.getTime() > vigIni.getTime()) {
        obj.vigenciaIni = hoje.toISOString();
        hoje.setFullYear(hoje.getFullYear() + 1);
        obj.vigenciaFim = hoje.toISOString();
      }

    for (let prop in obj) {
      if (obj === null)
        delete obj[prop];
    }

    obj.calculos = seguradoras.habilitadas.filter(function (cfg) { return cfg.ativo; });
    obj.calculos = obj.calculos.map(function (el) {
      let objCalc = { ...el, ...this.coberturasCalc };
      objCalc.percComissao = el.percCom ? parseInt(el.percCom) : 0;
      objCalc.percDesconto = el.percDesc ? parseInt(el.percDesc) : 0;

      this.utilsService.clearCfgSegToCalc(objCalc);

      if (!objCalc.libertyCodigoEstabelecimento)
        objCalc.libertyCodigoEstabelecimento = null;
      if (!objCalc.libertyDescontoRegional)
        objCalc.libertyDescontoRegional = 1;

      delete objCalc.ID;

      return objCalc;

    }.bind(this));

    if (obj.segurado.hasOwnProperty('estadoCivil') && (obj.segurado.estadoCivil == null || obj.segurado.estadoCivil == '')) {
      obj.segurado.estadoCivil = 1;
      // console.log('estadoCivil alterado para 1');
    }

    obj.segurado.tipoPessoa = "J";
    obj.tipoSeguro = 1
    obj.integracaoID = null

    if (!obj.configuracoes.imovelComplemento || obj.configuracoes.imovelComplemento === null) {
      obj.configuracoes.imovelComplemento = ''
    }



    return obj;
  }

  coberturasMerge(coberturas, obj) {
    return coberturas;
  }

  getSeguradorasStatus(seguradorasUser, servicesInfos, cfg) {

    let segStatus = JSON.parse(JSON.stringify(servicesInfos.calculos.condominio));

    for (let idx in segStatus) {

      let options = segStatus[idx];

      let reduced = options.reduce((filtered, option) => {

        if (seguradorasUser) {
          let seg = seguradorasUser.find((cfgUser) => { return option.id == cfgUser.seguradora; });

          if (seg && seg.seguradora != this._seguradorasBase.AZUL.id && seg.seguradora != this._seguradorasBase.ALIRO.id) {

            seg.idIntegracaoCfg = seg.ID;
            seg.idIntegracaoCfgSeg = seg.ID;

            seg.login = seg.usuario;

            seg.percCom = seg.percComissao;
            seg.percDesc = seg.percDesconto;

            let cfgSegConfig = { ...option, ...seg };

            filtered.push(cfgSegConfig);
          }
        }

        return filtered;

      }, []);

      segStatus[idx] = reduced;
      segStatus[idx].sort(function (a, b) {
        if (a.nome > b.nome) {
          return 1;
        }
        if (a.nome < b.nome) {
          return -1;
        }
        return 0;
      });

    }

    return segStatus;
  }

  async getCoberturasUser(api) {
    return null;
  }

  matStepRoute(action, selectedStep, flags) {
    switch (selectedStep) {
      case this._stepsId.formulario:
        if (action == 'next') {
          return 'enviarCalculo';
        } else if (action == 'previous') {
          return 'resultados';
        }
        break;
      case this._stepsId.simuladorComissoes:
        if (action == 'next') {
          return 'simuladorComissoes';
        } else if (action == 'previous') {
          return 'resultados';
        }
        break;
      case this._stepsId.enviarCalculo:
        if (action == 'next') {
          return 'calcular';
        } else if (action == 'previous') {
          if (flags.simuladorComissoes) {
            return 'simuladorComissoes';
          } else if (flags.calcular) {
            return 'resultados';
          } else {
            return 'formulario';
          }
        }
        break;
    }
  }

  createDraft(negocio, opt?) {

    if (!negocio)
      negocio = new CalcPacote();
    negocio.tipo = this.tipoReq;
    if (opt) {
      if (opt.seguradoUrl) {
        let propertiesToCopy = [
          'nome',
          'tipoPessoa',
          'cpfCnpj',
          'fone1',
          'fone',
          'email'
        ];
        propertiesToCopy.forEach((p) => {
          negocio.segurado[p] = opt.seguradoUrl[p];
        });
        negocio.segurado.seguradoUrl = true;
      }
      if (opt.negocioUrl) {
        negocio.negocioId = opt.negocioUrl;
      }
    }
    return negocio;
  }

  createVersions(arrayVersions) {
    return arrayVersions.map((v) => {

      // Se não tiver versão, é calculo antigo, e respectivamente é a primeira versão, ou
      // Versão é igual a 0 e foi somente salvo, sem calcular, não deveria acessar a tela de resultado, somente o formulario.
      if (!v.versao && v.versao !== 0)
        v.versao = 1;

      this.addVersion(v);

      this.utilsService.setResultsAll(v);
      this.utilsService.sortResults(v);

      return v;

    });
  }

  private addVersion(v) {

    v.configuracoes.usoImovelTxt = this.utilsService.usoResidencia(v.configuracoes.imovelUso);
    v.configuracoes.tipoImovelTxt = this.utilsService.tipoResidencia(v.configuracoes.imovelTipoResidencia);
    v.configuracoes.tipoConstrucaoTxt = this.utilsService.tipoConstrucao(v.configuracoes.imovelConstrucao, v.ramo);
    v.configuracoes.objetoSeguradoTxt = this.utilsService.imovelObjetoSegurado(v.configuracoes.imovelObjetoSegurado);

    v.configuracoes.isDanosIncendioRaioExplosaoTxtRS = v.configuracoes
      .isDanosIncendioRaioExplosao
      ? this.utilsService.numberFormat(
        parseFloat(v.configuracoes.isDanosIncendioRaioExplosao),
        true
      )
      : 'R$ 0,00';

    v.configuracoes.isDanosIncendioRaioExplosaoCondTxtRS = v.configuracoes
      .isDanosIncendioRaioExplosaoCond
      ? this.utilsService.numberFormat(
        parseFloat(v.configuracoes.isDanosIncendioRaioExplosaoCond),
        true
      )
      : 'R$ 0,00';

    v.configuracoes.isDanosAluguelTxtRS = v.configuracoes.isDanosAluguel
      ? this.utilsService.numberFormat(
        parseFloat(v.configuracoes.isDanosAluguel),
        true
      )
      : 'R$ 0,00';

    v.configuracoes.isDanosDesmoronamentoTxtRS = v.configuracoes
      .isDanosDesmoronamento
      ? this.utilsService.numberFormat(
        parseFloat(v.configuracoes.isDanosDesmoronamento),
        true
      )
      : 'R$ 0,00';

    v.configuracoes.isDanosEletricosTxtRS = v.configuracoes.isDanosEletricos
      ? this.utilsService.numberFormat(
        parseFloat(v.configuracoes.isDanosEletricos),
        true
      )
      : 'R$ 0,00';

    v.configuracoes.isDanosImpactoVeiculoTxtRS = v.configuracoes
      .isDanosImpactoVeiculo
      ? this.utilsService.numberFormat(
        parseFloat(v.configuracoes.isDanosImpactoVeiculo),
        true
      )
      : 'R$ 0,00';

    v.configuracoes.isDanosVendavalTxtRS = v.configuracoes
      .isDanosVendaval
      ? this.utilsService.numberFormat(
        parseFloat(v.configuracoes.isDanosVendaval),
        true
      )
      : 'R$ 0,00';

    v.configuracoes.isDanosRouboTxtRS = v.configuracoes.isDanosRoubo
      ? this.utilsService.numberFormat(
        parseFloat(v.configuracoes.isDanosRoubo),
        true
      )
      : 'R$ 0,00';

    v.configuracoes.isDanosVidrosTxtRS = v.configuracoes.vidros
      ? this.utilsService.numberFormat(parseFloat(v.configuracoes.vidros), true)
      : 'R$ 0,00';

    v.configuracoes.responsabilidadeCivilTxtRS = v.configuracoes
      .responsabilidadeCivil
      ? this.utilsService.numberFormat(
        parseFloat(v.configuracoes.responsabilidadeCivil),
        true
      )
      : 'R$ 0,00';

    v.configuracoes.assist24hsTxt = v.configuracoes.assist24hs
      ? this.utilsService.tipoAssistencia24h(v.configuracoes.assist24hs)
      : 'Não';

    v.configuracoes.tipoCondominioTxt =
      this._tipoCondominioTxt[v.configuracoes.imovelAtividade];

    v.configuracoes.isValorCondominioTxtRS = v.configuracoes.isValorCondominio
      ? this.utilsService.numberFormat(
        parseFloat(v.configuracoes.isValorCondominio),
        true
      )
      : 'R$ 0,00';

    v.configuracoes.isDanosPortoesTxtRS = v.configuracoes.isDanosPortoes
      ? this.utilsService.numberFormat(
        parseFloat(v.configuracoes.isDanosPortoes),
        true
      )
      : 'R$ 0,00';

    v.configuracoes.valGuardaTerceirizadaTxtRS = v.configuracoes
      .valGuardaTerceirizada
      ? this.utilsService.numberFormat(
        parseFloat(v.configuracoes.valGuardaTerceirizada),
        true
      )
      : 'R$ 0,00';

    v.configuracoes.isValorSindicoTxtRS = v.configuracoes.isValorSindico
      ? this.utilsService.numberFormat(
        parseFloat(v.configuracoes.isValorSindico),
        true
      )
      : 'R$ 0,00';

    v.configuracoes.isDanosMoraisTxtRS = v.configuracoes.isDanosMorais
      ? this.utilsService.numberFormat(
        parseFloat(v.configuracoes.isDanosMorais),
        true
      )
      : 'R$ 0,00';

    v.configuracoes.isDanosVazamentoTanquesTubulacoesTxtRS = v.configuracoes
      .isDanosVazamentoTanquesTubulacoes
      ? this.utilsService.numberFormat(
        parseFloat(v.configuracoes.isDanosVazamentoTanquesTubulacoes),
        true
      )
      : 'R$ 0,00';

    v.configuracoes.anunciosLuminososTxtRS = v.configuracoes
    .anunciosLuminosos
    ? this.utilsService.numberFormat(
      parseFloat(v.configuracoes.anunciosLuminosos),
      true
    )
    : 'R$ 0,00';

    v.configuracoes.tumultoGreveLockOutTxtRS = v.configuracoes
    .tumultoGreveLockOut
    ? this.utilsService.numberFormat(
      parseFloat(v.configuracoes.tumultoGreveLockOut),
      true
    )
    : 'R$ 0,00';

    v.configuracoes.isDanosAlagamentoTxtRS = v.configuracoes
    .isDanosAlagamento
    ? this.utilsService.numberFormat(
      parseFloat(v.configuracoes.isDanosAlagamento),
      true
    )
    : 'R$ 0,00';

    v.configuracoes.isDanosDespesasFixasTxtRS = v.configuracoes
    .isDanosDespesasFixas
    ? this.utilsService.numberFormat(
      parseFloat(v.configuracoes.isDanosDespesasFixas),
      true
    )
    : 'R$ 0,00';

    v.configuracoes.equipamentosTxtRS = v.configuracoes
    .equipamentos
    ? this.utilsService.numberFormat(
      parseFloat(v.configuracoes.equipamentos),
      true
    )
    : 'R$ 0,00';

    v.configuracoes.isEmpregadorTxtRS = v.configuracoes
    .isEmpregador
    ? this.utilsService.numberFormat(
      parseFloat(v.configuracoes.isEmpregador),
      true
    )
    : 'R$ 0,00';

    v.configuracoes.isVGFuncionariosTxtRS = v.configuracoes
    .isVGFuncionarios
    ? this.utilsService.numberFormat(
      parseFloat(v.configuracoes.isVGFuncionarios),
      true
    )
    : 'R$ 0,00';

    v.configuracoes.chuveiroSprinklerTxtRS = v.configuracoes
    .chuveiroSprinkler
    ? this.utilsService.numberFormat(
      parseFloat(v.configuracoes.chuveiroSprinkler),
      true
    )
    : 'R$ 0,00';

    v.configuracoes.placasSolaresTxtRS = v.configuracoes
    .placasSolares
    ? this.utilsService.numberFormat(
      parseFloat(v.configuracoes.placasSolares),
      true
    )
    : 'R$ 0,00';

    v.configuracoes.garagistaTxtRS = v.configuracoes
    .garagista
    ? this.utilsService.numberFormat(
      parseFloat(v.configuracoes.garagista),
      true
    )
    : 'R$ 0,00';

    v.configuracoes.garagistaExclusivaTxtRS = v.configuracoes
    .garagistaExclusiva
    ? this.utilsService.numberFormat(
      parseFloat(v.configuracoes.garagistaExclusiva),
      true
    )
    : 'R$ 0,00';

    let guarda = '';

    this.tpGuardaVeic.forEach((item) => {
      if (item.value === v.configuracoes.tpGuardaTerceirizada) {
        guarda = item.viewValue;
      }
    })


    v.configuracoes.tpGuardaTerceirizadaTxtRS = guarda;
    v.configuracoes.vidaGrupoTxt = this.vidaGrupoTxt[v.configuracoes.vidaGrupo];
    v.configuracoes.qtdVagasGaragemTxt = this.qtdVagasGaragem[v.configuracoes.qtdVagasGaragem];
    v.configuracoes.estruturaCondominioTxt = v.configuracoes.estruturaCondominio === 1
      ? 'Vertical' : 'Horizontal';

    v.configuracoes.areaConstruidaTxt = v.configuracoes.areaConstruida ? `${v.configuracoes.areaConstruida} M²` : 'Não informada';
    v.configuracoes.qtdFuncionariosTxt = v.configuracoes.qtdFuncionarios ? String(v.configuracoes.qtdFuncionarios) : 'Não informada';
    v.configuracoes.qtdBlocosTxt = v.configuracoes.qtdBlocos ? String(v.configuracoes.qtdBlocos) : 'Não informada';
    v.configuracoes.pavimentosTxt = v.configuracoes.pavimentos ? String(v.configuracoes.pavimentos) : 'Não informada';

    v.configuracoes.modalidadeTxt = v.configuracoes.modalidade === 1
      ? 'Simples' : 'Ampla';

    v.vigenciaIniTxt = this.utilsService.dateStringToTxt(v.vigenciaIni);
    v.vigenciaFimTxt = this.utilsService.dateStringToTxt(v.vigenciaFim);

    v.numeroRenovacaoTxt = v.numeroRenovacao ? v.numeroRenovacao : 'Não informada';

    v.segurado.cpfCnpjTxt = this.utilsService.cpfCnpj(v.segurado.cpfCnpj);
    v.segurado.dataNascTxt = this.utilsService.dateStringToTxt(v.segurado.dataNasc);
    v.segurado.sexoTxt = this._sexo[v.segurado.sexo];
    v.segurado.profissaoTxt = this._profissoes[v.segurado.profissao];
    v.segurado.estadoCivilTxt = this._estadoCivil[v.segurado.estadoCivil];

    v.segurado.cepTxt = this.utilsService.formatCep(v.segurado.cep);

    v.results = new CalcsResults();

    this.updateResults(v);

  }

  adicionarLeads(v){
    var leads = this._leadsCadastrados;
    var storage:any = localStorage.getItem('nao-exibir-leads' )

    if (typeof storage == 'string')
       storage = JSON.parse(storage)

    storage = Array.isArray(storage) ? storage  : []

    leads = leads.filter(item =>{
       var temConfig = this.dadosUser.find(c => c.seguradora == item.seguradoraId)

       let temCalcuSeg = v.calculos.find(c => c.seguradora == item.seguradoraId)

       if (temConfig.ativo || temCalcuSeg)
          return false

       let seg = storage.find(s => s.seg == item.seguradoraId )

       return seg ? false : true
    })

    leads.forEach(l =>{
      if (l.ramos.vida)
          v.results.main["successes"].push(l)
    })
  }

  public updateResults(v) {
    v.calculos.map((vr) => {
      this.extractResultsPacote(v, vr);
    });
    this.utilsService.setResultsAll(v);
    this.utilsService.sortResults(v);
    this.adicionarLeads(v);
  }

  private extractResultsPacote(v, calc) {
    let conf = v.configuracoes;
    var cob: any = {
      isDanosIncendioRaioExplosaoTxt: conf.isDanosIncendioRaioExplosao ? this.utilsService.numberFormat(parseFloat(conf.isDanosIncendioRaioExplosao)) : '--',
      isDanosIncendioRaioExplosaoTxtRS: conf.isDanosIncendioRaioExplosao ? conf.isDanosIncendioRaioExplosaoTxtRS : '--',
      isDanosAluguelTxt: conf.isDanosAluguel ? this.utilsService.numberFormat(parseFloat(conf.isDanosAluguel)) : '--',
      isDanosAluguelTxtRS: conf.isDanosAluguel ? conf.isDanosAluguelTxtRS : '',
      isDanosDesmoronamentoTxt: conf.isDanosDesmoronamento ? this.utilsService.numberFormat(parseFloat(conf.isDanosDesmoronamento)) : '--',
      isDanosDesmoronamentoTxtRS: conf.isDanosDesmoronamento ? conf.isDanosDesmoronamentoTxtRS : '',
      isDanosEletricosTxt: conf.isDanosEletricos ? this.utilsService.numberFormat(parseFloat(conf.isDanosEletricos)) : '--',
      isDanosEletricosTxtRS: conf.isDanosEletricos ? conf.isDanosEletricosTxtRS : '--',
      isDanosImpactoVeiculoTxt: conf.isDanosImpactoVeiculo ? this.utilsService.numberFormat(parseFloat(conf.isDanosImpactoVeiculo)) : '--',
      isDanosImpactoVeiculoTxtRS: conf.isDanosImpactoVeiculo ? conf.isDanosImpactoVeiculoTxtRS : '--',
      isDanosVendavalTxt: conf.isDanosVendaval ? this.utilsService.numberFormat(parseFloat(conf.isDanosVendaval)) : '--',
      isDanosVendavalTxtRS: conf.isDanosVendaval ? conf.isDanosVendavalTxtRS : '--',
      isDanosRouboTxt: conf.isDanosRoubo ? this.utilsService.numberFormat(parseFloat(conf.isDanosRoubo)) : '--',
      isDanosRouboTxtRS: conf.isDanosRoubo ? conf.isDanosRouboTxtRS : '--',
      isValorSindicoTxt: conf.isValorSindico ? this.utilsService.numberFormat(parseFloat(conf.isValorSindico)) : '--',
      isValorSindicoTxtRS: conf.isValorSindico ? conf.isValorSindicoTxtRS : '--',
      isDanosVidrosTxt: conf.vidros ? this.utilsService.numberFormat(parseFloat(conf.vidros)) : '--',
      isDanosVidrosTxtRS: conf.vidros ? conf.vidrosTxtRS : '',
      isDanosIncendioRaioExplosaoCondTxt: conf.isDanosIncendioRaioExplosaoCond ? this.utilsService.numberFormat(parseFloat(conf.isDanosIncendioRaioExplosaoCond)) : '--',
      isDanosIncendioRaioExplosaoCondTxtRS: conf.isDanosIncendioRaioExplosaoCond ? conf.isDanosIncendioRaioExplosaoCondTxtRS : '',
      isValorCondominioTxt: conf.isValorCondominio ? this.utilsService.numberFormat(parseFloat(conf.isValorCondominio)) : '--',
      isValorCondominioTxtRS: conf.isValorCondominio ? conf.isValorCondominioTxtRS : '',
      isDanosPortoesTxt: conf.isDanosPortoes ? this.utilsService.numberFormat(parseFloat(conf.isDanosPortoes)) : '--',
      isDanosPortoesTxtRS: conf.isDanosPortoes ? conf.isDanosPortoesTxtRS : '',
      isDanosMoraisTxt: conf.isDanosMorais ? this.utilsService.numberFormat(parseFloat(conf.isDanosMorais)) : '--',
      isDanosMoraisTxtRS: conf.isDanosMorais ? conf.isDanosMoraisTxtRS : '',
      isDanosVazamentoTanquesTubulacoesTxt: conf.isDanosVazamentoTanquesTubulacoes ? this.utilsService.numberFormat(parseFloat(conf.isDanosMorais)) : '--',
      isDanosVazamentoTanquesTubulacoesTxtRS: conf.isDanosVazamentoTanquesTubulacoes ? conf.isDanosVazamentoTanquesTubulacoesTxtRS : '',
      anunciosLuminososTxt: conf.anunciosLuminosos ? this.utilsService.numberFormat(parseFloat(conf.anunciosLuminosos)) : '--',
      anunciosLuminososTxtRS: conf.anunciosLuminosos ? conf.anunciosLuminososTxtRS : '',
      tumultoGreveLockOutTxt: conf.tumultoGreveLockOut ? this.utilsService.numberFormat(parseFloat(conf.tumultoGreveLockOut)) : '--',
      tumultoGreveLockOutTxtRS: conf.tumultoGreveLockOut ? conf.tumultoGreveLockOutTxtRS : '',
      isDanosAlagamentoTxt: conf.isDanosAlagamento ? this.utilsService.numberFormat(parseFloat(conf.isDanosAlagamento)) : '--',
      isDanosAlagamentoTxtRS: conf.isDanosAlagamento ? conf.isDanosAlagamentoTxtRS : '',
      isDanosDespesasFixasTxt: conf.isDanosDespesasFixas ? this.utilsService.numberFormat(parseFloat(conf.isDanosDespesasFixas)) : '--',
      isDanosDespesasFixasTxtRS: conf.isDanosDespesasFixas ? conf.isDanosDespesasFixasTxtRS : '',
      equipamentosTxt: conf.equipamentos ? this.utilsService.numberFormat(parseFloat(conf.equipamentos)) : '--',
      equipamentosTxtRS: conf.equipamentos ? conf.equipamentosTxtRS : '',
      isEmpregadorTxt: conf.isEmpregador ? this.utilsService.numberFormat(parseFloat(conf.isEmpregador)) : '--',
      isEmpregadorTxtRS: conf.isEmpregador ? conf.isEmpregadorTxtRS : '',
      isVGFuncionariosTxt: conf.isVGFuncionarios ? this.utilsService.numberFormat(parseFloat(conf.isVGFuncionarios)) : '--',
      isVGFuncionariosTxtRS: conf.isVGFuncionarios ? conf.isVGFuncionariosTxtRS : '',
      chuveiroSprinklerTxt: conf.chuveiroSprinkler ? this.utilsService.numberFormat(parseFloat(conf.chuveiroSprinkler)) : '--',
      chuveiroSprinklerTxtRS: conf.chuveiroSprinkler ? conf.chuveiroSprinklerTxtRS : '',
      placasSolaresTxt: conf.placasSolares ? this.utilsService.numberFormat(parseFloat(conf.placasSolares)) : '--',
      placasSolaresTxtRS: conf.placasSolares ? conf.placasSolaresTxtRS : '',
      garagistaTxt: conf.garagista ? this.utilsService.numberFormat(parseFloat(conf.garagista)) : '--',
      garagistaTxtRS: conf.garagista ? conf.garagistaTxtRS : '',
      garagistaExclusivaTxt: conf.garagistaExclusiva ? this.utilsService.numberFormat(parseFloat(conf.garagistaExclusiva)) : '--',
      garagistaExclusivaTxtRS: conf.garagistaExclusiva ? conf.garagistaExclusivaTxtRS : '',
      assist24hsTxt: conf.assist24hs ? this.utilsService.tipoAssistencia24h(conf.assist24hs) : '--',
      assist24hsTxtMod: conf.assist24hs ? this.utilsService.tipoAssistencia24h(conf.assist24hs) : '',
      percComissao: calc.percComissao,
      percDesconto: 0,
      percComissaoTxt: calc.percComissao ? (calc.percComissao + '%') : '--',
    };

    if (calc.resultados) {
      calc.resultados.map(function (vrr) {
        try {
          let cobertura = vrr.coberturas
          cobertura.percComissao && cobertura.percComissao != false ? cob.percComissaoTxt = (cobertura.percComissao + '%') : cob.percComissaoTxt = (calc.percComissao + '%')
        } catch (e) {
          console.log(e)
        }
      })
    }

    if (calc.resultados && calc.resultados.length) {

      let id = 0;

      calc.resultados.map(function (vrr) {

        id = id + 1;
        vrr.ramo = v.ramo;

        vrr.idPacote = calc.seguradora + '-' + id;
        vrr.nome = this.utilsService.getSegNameById(calc.seguradora);
        vrr.logo = this.utilsService.getPathLogoById(calc.seguradora);

        vrr.idIntegracaoCfgSeg = calc.idIntegracaoCfgSeg;
        vrr.idIntegracaoCfg = calc.idIntegracaoCfg;
        vrr.seguradora = calc.seguradora;

        vrr.tempoResposta = calc.tempoResposta / 1000;
        vrr.isError = calc.erros ? calc.erros.length > 0 : false;

        if (vrr.principal && !vrr.identificacao) {
          vrr.identificacao = 'Principal';
        } else if (!vrr.principal && !vrr.identificacao) {
          vrr.identificacao = 'Alternativo';
        }

        vrr.identificacaoLim = vrr.identificacao;

        if (vrr.identificacaoLim.length >= 24) {
          vrr.identificacaoLim = vrr.identificacaoLim.replace(/(.{0,22}).*/, '$1...');
        }

        vrr.retorno = calc.retorno;
        vrr.nroCalculo = vrr.nroCalculo ? vrr.nroCalculo : calc.nroCalculo;

        if (!vrr.hasOwnProperty('coberturas')) vrr['coberturas'] = {};

        if ((!vrr.isError && !vrr.premio))
          vrr.isError = true;
        vrr.premioTxt = vrr.premio ? this.utilsService.numberFormat(parseFloat(vrr.premio)) : '--';
        vrr.premioTxtRS = vrr.premio ? this.utilsService.numberFormat(parseFloat(vrr.premio), true) : '--';

        vrr.coberturas.isDanosIncendioRaioExplosaoTxt = vrr.coberturas
          .isDanosIncendioRaioExplosao
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosIncendioRaioExplosao)
          )
          : '--';
        vrr.coberturas.isDanosIncendioRaioExplosaoTxtRS = vrr.coberturas
          .isDanosIncendioRaioExplosao
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosIncendioRaioExplosao), true
          )
          : '--';
        vrr.coberturas.isDanosAluguelTxt = vrr.coberturas.isDanosAluguel
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosAluguel)
          )
          : '--';
        vrr.coberturas.isDanosAluguelTxtRS = vrr.coberturas.isDanosAluguel
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosAluguel), true
          )
          : '';
        vrr.coberturas.isDanosDesmoronamentoTxt = vrr.coberturas
          .isDanosDesmoronamento
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosDesmoronamento)
          )
          : '--';
        vrr.coberturas.isDanosDesmoronamentoTxtRS = vrr.coberturas
          .isDanosDesmoronamento
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosDesmoronamento), true
          )
          : '';
        vrr.coberturas.isDanosEletricosTxt = vrr.coberturas.isDanosEletricos
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosEletricos)
          )
          : '--';
        vrr.coberturas.isDanosEletricosTxtRS = vrr.coberturas.isDanosEletricos
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosEletricos), true
          )
          : '--';
        vrr.coberturas.isValorSindicoTxt = vrr.coberturas.isValorSindico
        ? this.utilsService.numberFormat(
          parseFloat(vrr.coberturas.isValorSindico)
        )
        : '--';
        vrr.coberturas.isValorSindicoTxtRS = vrr.coberturas.isValorSindico
        ? this.utilsService.numberFormat(
          parseFloat(vrr.coberturas.isValorSindico), true
        )
        : '--';
        vrr.coberturas.isDanosImpactoVeiculoTxt = vrr.coberturas
          .isDanosImpactoVeiculo
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosImpactoVeiculo)
          )
          : '--';
        vrr.coberturas.isDanosImpactoVeiculoTxtRS = vrr.coberturas
          .isDanosImpactoVeiculo
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosImpactoVeiculo), true
          )
          : '--';
        vrr.coberturas.isDanosVendavalTxt = vrr.coberturas
          .isDanosVendaval
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosVendaval)
          )
          : '--';
        vrr.coberturas.isDanosVendavalTxtRS = vrr.coberturas
          .isDanosVendaval
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosVendaval), true
          )
          : '--';
        vrr.coberturas.isDanosRouboTxt = vrr.coberturas.isDanosRoubo
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosRoubo)
          )
          : '--';
        vrr.coberturas.isDanosRouboTxtRS = vrr.coberturas.isDanosRoubo
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosRoubo), true
          )
          : '--';
        vrr.coberturas.isDanosVidrosTxt = vrr.coberturas.vidros
          ? this.utilsService.numberFormat(parseFloat(vrr.coberturas.vidros))
          : '--';
        vrr.coberturas.isDanosVidrosTxtRS = vrr.coberturas.vidros
          ? this.utilsService.numberFormat(parseFloat(vrr.coberturas.vidros), true)
          : '';
        vrr.coberturas.isDanosIncendioRaioExplosaoCondTxt = vrr.coberturas.isDanosIncendioRaioExplosaoCond
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosIncendioRaioExplosaoCond)
          )
          : '--';
        vrr.coberturas.isDanosIncendioRaioExplosaoCondTxtRS = vrr.coberturas.isDanosIncendioRaioExplosaoCond
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosIncendioRaioExplosaoCond), true
          )
          : '--';            
        vrr.coberturas.isValorCondominioTxt = vrr.coberturas.isValorCondominio
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isValorCondominio)
          )
          : '--';
        vrr.coberturas.isValorCondominioTxtRS = vrr.coberturas.isValorCondominio
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isValorCondominio), true
          )
          : '--';
        vrr.coberturas.isDanosPortoesTxt = vrr.coberturas.isDanosPortoes
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosPortoes)
          )
          : '--';
        vrr.coberturas.isDanosPortoesTxtRS = vrr.coberturas.isDanosPortoes
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosPortoes), true
          )
          : '--';     
        vrr.coberturas.isDanosMoraisTxt = vrr.coberturas.isDanosMorais
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosMorais)
          )
          : '--';
        vrr.coberturas.isDanosMoraisTxtRS = vrr.coberturas.isDanosMorais
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosMorais), true
          )
          : '--';      
        vrr.coberturas.isDanosVazamentoTanquesTubulacoesTxt = vrr.coberturas.isDanosVazamentoTanquesTubulacoes
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosVazamentoTanquesTubulacoes)
          )
          : '--';
        vrr.coberturas.isDanosVazamentoTanquesTubulacoesTxtRS = vrr.coberturas.isDanosVazamentoTanquesTubulacoes
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosVazamentoTanquesTubulacoes), true
          )
          : '--';                                
        vrr.coberturas.anunciosLuminososTxt = vrr.coberturas.anunciosLuminosos
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.anunciosLuminosos)
          )
          : '--';
        vrr.coberturas.anunciosLuminososTxtRS = vrr.coberturas.anunciosLuminosos
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.anunciosLuminosos), true
          )
          : '--';
        vrr.coberturas.tumultoGreveLockOutTxt = vrr.coberturas.tumultoGreveLockOut
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.tumultoGreveLockOut)
          )
          : '--';
        vrr.coberturas.tumultoGreveLockOutTxtRS = vrr.coberturas.tumultoGreveLockOut
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.tumultoGreveLockOut), true
          )
          : '--';            
        vrr.coberturas.isDanosAlagamentoTxt = vrr.coberturas.isDanosAlagamento
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosAlagamento)
          )
          : '--';
        vrr.coberturas.isDanosAlagamentoTxtRS = vrr.coberturas.isDanosAlagamento
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosAlagamento), true
          )
          : '--';
        vrr.coberturas.isDanosDespesasFixasTxt = vrr.coberturas.isDanosDespesasFixas
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosDespesasFixas)
          )
          : '--';
        vrr.coberturas.isDanosDespesasFixasTxtRS = vrr.coberturas.isDanosDespesasFixas
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isDanosDespesasFixas), true
          )
          : '--';
        vrr.coberturas.equipamentosTxt = vrr.coberturas.equipamentos
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.equipamentos)
          )
          : '--';
        vrr.coberturas.equipamentosTxtRS = vrr.coberturas.equipamentos
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.equipamentos), true
          )
          : '--';     
        vrr.coberturas.isEmpregadorTxt = vrr.coberturas.isEmpregador
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isEmpregador)
          )
          : '--';
        vrr.coberturas.isEmpregadorTxtRS = vrr.coberturas.isEmpregador
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isEmpregador), true
          )
          : '--';     
        vrr.coberturas.isVGFuncionariosTxt = vrr.coberturas.isVGFuncionarios
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isVGFuncionarios)
          )
          : '--';
        vrr.coberturas.isVGFuncionariosTxtRS = vrr.coberturas.isVGFuncionarios
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.isVGFuncionarios), true
          )
          : '--';             
        vrr.coberturas.garagistaTxt = vrr.coberturas.garagista
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.garagista)
          )
          : '--';
        vrr.coberturas.garagistaTxtRS = vrr.coberturas.garagista
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.garagista), true
          )
          : '--';    
        vrr.coberturas.garagistaExclusivaTxt = vrr.coberturas.garagistaExclusiva
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.garagistaExclusiva)
          )
          : '--';
        vrr.coberturas.garagistaExclusivaTxtRS = vrr.coberturas.garagistaExclusiva
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.garagistaExclusiva), true
          )
          : '--';      
        vrr.coberturas.chuveiroSprinklerTxt = vrr.coberturas.chuveiroSprinkler
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.chuveiroSprinkler)
          )
          : '--';
        vrr.coberturas.chuveiroSprinklerTxtRS = vrr.coberturas.chuveiroSprinkler
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.chuveiroSprinkler), true
          )
          : '--';    
        vrr.coberturas.placasSolaresTxt = vrr.coberturas.placasSolares
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.placasSolares)
          )
          : '--';
        vrr.coberturas.placasSolaresTxtRS = vrr.coberturas.placasSolares
          ? this.utilsService.numberFormat(
            parseFloat(vrr.coberturas.placasSolares), true
          )
          : '--';                                                            

        vrr.coberturas.assist24hsTxt = vrr.coberturas.assist24hs ? vrr.coberturas.assist24hs : '--';
        vrr.coberturas.assist24hsTxtMod = vrr.coberturas.assist24hs;
        vrr.coberturas.percComissao = vrr.percComissao;
        vrr.coberturas.percDesconto = 0;
        vrr.coberturas.percComissaoTxt = vrr.percComissao ? (vrr.percComissao + '%') : '--';

        

        if (v.ramo == this._ramos.RESIDENCIAL) {

          if (vrr.premio)
            vrr.premioImovel = vrr.premio;

          if ((!vrr.isError && !vrr.premioImovel))
            vrr.isError = true;

          vrr.premioTxt = vrr.premioImovel ? this.utilsService.numberFormat(parseFloat(vrr.premioImovel)) : '--';
          vrr.premioTxtRS = vrr.premioImovel ? this.utilsService.numberFormat(parseFloat(vrr.premioImovel), true) : '--';
        }

        vrr.franquiaTxt = vrr.valorFranquia ? this.utilsService.numberFormat(parseFloat(vrr.valorFranquia)) : '--';

        if (parseFloat(vrr.valorFranquia) == 0)
          vrr.franquiaTxt = '--';

        let isAlternative = this.utilsService.isCalcAutoAlternative(calc.seguradora);

        if (calc.erros)
          calc.erros.forEach(function (ce, idx) {
            calc.erros[idx] = this.utilsService.fixString(ce);
          }.bind(this));


        // vrr.parcelamentos = vrr.parcelamentos;

        vrr.msErros = calc.erros;

        vrr.msAlertas = vrr.alertas ? vrr.alertas.concat( calc.alertas ) : calc.alertas;

        let arrToAdd = vrr.isError ? 'errors' : 'successes';
        if (vrr.hasOwnProperty('packageType') && Object.values(this._packageType).includes(vrr.packageType)) {
          if (vrr.packageType === this._packageType.PRINCIPAL) {
            vrr.isAlternative = !vrr?.selected;
            v.results[vrr?.selected ? 'main' : 'alternatives'][arrToAdd].push(vrr);
          } else if (vrr.packageType === this._packageType.MENSAL) {
            vrr.isPorAssinatura = true;
            v.results.porAssinatura[arrToAdd].push(vrr);
          } else {
            vrr.isAlternative = true;
            v.results.alternatives[arrToAdd].push(vrr);
          }
        } else {
          let isPorAssinatura = this.utilsService.isCalcPorAssinatura(calc.seguradora);

          if (isPorAssinatura) {
            vrr.isPorAssinatura = true;
            v.results.porAssinatura[arrToAdd].push(vrr);
          } else {
            if (vrr.principal && !isAlternative) {
              vrr.isAlternative = false;
              v.results.main[arrToAdd].push(vrr);
            } else if ((!calc.retornoErro && !vrr.isError) || isAlternative) {
              vrr.isAlternative = true;
              v.results.alternatives[arrToAdd].push(vrr);
            }
          }
        }
      }.bind(this));

    } else {

      let identificacaoLim = 'Principal';

      if (identificacaoLim.length >= 24)
        identificacaoLim = identificacaoLim.replace(/(.{0,22}).*/, '$1...');

      let gerarPacote = {
        nroCalculo: calc.nroCalculo,
        principal: true,
        identificacao: 'Principal',
        identificacaoLim: 'Principal',
        nome: this.utilsService.getSegNameById(calc.seguradora),
        logo: this.utilsService.getPathLogoById(calc.seguradora),
        tempoResposta: calc.tempoResposta ? (calc.tempoResposta / 1000) : '--',
        idPacote: calc.seguradora,
        seguradora: calc.seguradora,
        isError: null,
        retorno: calc.retorno,
        msErros: calc.erros,
        msAlertas: calc.alertas,
        premioTxt: calc.premio ? this.utilsService.numberFormat(parseFloat(calc.premio)) : '--',
        franquiaTxt: calc.franquia ? this.utilsService.numberFormat(parseFloat(calc.franquia)) : '',
        premioTxtRS: calc.premio ? this.utilsService.numberFormat(parseFloat(calc.premio), true) : '--',
        franquiaTxtRS: calc.franquia ? this.utilsService.numberFormat(parseFloat(calc.franquia), true) : '',
        coberturas: calc.retorno ? cob : {},
        parcelamentos: calc.parcelamentos,
        idIntegracaoCfgSeg: calc.idIntegracaoCfgSeg,
        idIntegracaoCfg: calc.idIntegracaoCfg,
      };

      if ((calc.erros && calc.erros.length > 0) || calc.retornoErro) {
        gerarPacote.isError = true;

        if (!calc.erros && calc.retornoErro && calc.mensagemTxt) // acredito que isso já foi corrigido nos bots, pelo que entendi são cálculos de meses atrás (hoje 22/02/2021)
          gerarPacote.msErros = [calc.mensagemTxt];
      }

      // gerarPacote.isError = calc.erros ? calc.erros.length > 0 : false;
      let arrToAdd = gerarPacote.isError ? 'errors' : 'successes';

      let commomProperties = ['desconto', 'descontoComercial', 'premio', 'franquia'];
      commomProperties.map(function (cpm) {
        gerarPacote[cpm] = calc[cpm];
      });
      if (calc.hasOwnProperty('packageType') && Object.values(this._packageType).includes(calc.packageType)) {
        if (calc.packageType === this._packageType.PRINCIPAL)
          v.results[calc?.selected ? 'main' : 'alternatives'][arrToAdd].push(gerarPacote);
        else if (calc.packageType === this._packageType.MENSAL)
          v.results.porAssinatura[arrToAdd].push(gerarPacote);
        else
          v.results.alternatives[arrToAdd].push(gerarPacote);
      } else {
        let isPorAssinatura = this.utilsService.isCalcPorAssinatura(calc.seguradora);

        if (isPorAssinatura) {
          v.results.porAssinatura[arrToAdd].push(gerarPacote);
        } else {
          let isAlternative = this.utilsService.isCalcAutoAlternative(calc.seguradora);
          if (gerarPacote.principal && !isAlternative)
            v.results.main[arrToAdd].push(gerarPacote);
          else if ((!calc.retornoErro && !gerarPacote.isError) || isAlternative)
            v.results.alternatives[arrToAdd].push(gerarPacote);
        }
      }
    }
  }

}
